import {useEffect, useRef, useState} from "react";
import SockJS from "sockjs-client";
import {Client} from "@stomp/stompjs";
import {TOKEN} from "../context/SignInContext";
import {refreshConnectHeaders} from "../utils/authTokens";

export const useStompWebsocketRag = (topic) => {
    const stompClientRef = useRef(null);
    const [updatedValue, setUpdatedValue] = useState(null);
    const [status, setStatus] = useState(null);

    useEffect(() => {
        let stompClient = null;

        const setupWebSocket = async () => {
            const wsBaseUrl = process.env.REACT_APP_KB_WS_URL;
            const socket = new SockJS(wsBaseUrl);

            const token = localStorage.getItem(TOKEN);
            stompClient = new Client({
                webSocketFactory: () => socket,
                connectHeaders: token ? {Authorization: `Bearer ${token}`} : {},
                beforeConnect: refreshConnectHeaders,
                debug: (str) => {
                    console.log("STOMP-RAG: ", str);
                },
                reconnectDelay: 5000,
                heartbeatIncoming: 4000,
                heartbeatOutgoing: 4000,
            });

            stompClient.onConnect = () => {
                console.log("RAG WebSocket connected");
                setStatus("CONNECTED");
                stompClient?.subscribe(topic, (message) => {
                    try {
                        const update = JSON.parse(message.body);
                        console.log("STOMP-RAG MESSAGE RECEIVE", update);
                        if (!update) return;
                        setUpdatedValue(update);
                    } catch (error) {
                        console.error("Error processing RAG WebSocket message:", error);
                    }
                });
            };

            stompClient.onStompError = (frame) => {
                console.error("RAG STOMP error:", frame);
                setStatus("ERROR");
            };

            stompClient.activate();
            stompClientRef.current = stompClient;
        };

        if (topic) {
            setupWebSocket();
        }

        return () => {
            if (stompClientRef?.current) {
                stompClientRef.current.deactivate();
            }
        };
    }, [topic]);

    return [updatedValue, status];
};